import { updateListMethod } from '../../utils/list'
import {
  SUBJECT_UPDATE_LIST,
  SUBJECT_UPDATE_LIST_METHOD,
  SUBJECT_UPDATE_ERROR,
  SUBJECT_UPDATE_FORM,
  SUBJECT_UPDATE_FORM_FIELD,
  SUBJECT_UPDATE_PREVIEW
} from '../actions/subjects.actions'

const initialState = {
  list: [],
  totalList: 0,
  form: {},
  preview: null
}

const subjectReducer = (state = initialState, action) => {
  const newState = { ...state }
  const { type, payload } = action

  switch (type) {
    case SUBJECT_UPDATE_LIST:
      if (payload.curriculumId) {
        newState[payload.curriculumId] = { list: payload.data, totalList: payload.count }
      } else {
        newState.list = payload.data
        newState.totalList = payload.count
      }
    break
    case SUBJECT_UPDATE_LIST_METHOD:
      if (payload.curriculumId) {
        if (newState[payload.curriculumId]) {
          newState[payload.curriculumId].list = updateListMethod(payload.method, payload.data, newState[payload.curriculumId].list)
          if (payload.method === 'DELETE') {
            newState[payload.curriculumId].totalList--
          }
          if (payload.method === 'POST') {
            newState[payload.curriculumId].totalList++
          }
        } else {
          newState[payload.curriculumId] = { list: updateListMethod(payload.method, payload.data, []), totalList: 1 }
        }
      } else {
        newState.list = updateListMethod(payload.method, payload.data, newState.list)
        if (payload.method === 'DELETE') {
          newState.totalList--
        }
        if (payload.method === 'POST') {
          newState.totalList++
        }
      }
    break
    case SUBJECT_UPDATE_ERROR:
      newState.error = payload
    break
    case SUBJECT_UPDATE_FORM:
      newState.form = payload
    break
    case SUBJECT_UPDATE_FORM_FIELD:
      newState.form = { ...newState.form, [payload.field]: payload.value }
      newState.error = { ...newState.error, [payload.field]: null }
    break
    case SUBJECT_UPDATE_PREVIEW:
      newState.preview = payload
    break
    default:
      break
  }

  return newState
}

export default subjectReducer